import type { MenuConfig } from '~typings/menu'

export default [
    {
        title: 'tablero.menu_title',
        icon: 'TrendingUpIcon',
        resource: 'Tablero Control',
        action: 'ver-tablero-control',
        children: [
            {
                title: 'tablero.general.menu_title',
                // fontIcon: 'chart-column',
                route: 'tablero-control-general',
                resource: 'TableroControl',
                action: 'ver-tablero-control-dashboard-general',
            },
            {
                title: 'tablero.comercio_exterior.menu_title',
                fontIcon: "ship",
                resource: 'Tablero Control',
                action: 'ver-tablero-control-comercio-exterior',
                children: [
                    {
                        title: 'tablero.comercio_exterior.menu_exportaciones',
                        route: 'tablero-control-comercio-exterior-exportaciones',
                        resource: 'Tablero Control',
                        action: 'ver-tablero-control-comercio-exterior-exportaciones',
                    },
                    {
                        title: 'tablero.comercio_exterior.menu_vta_x_cliente',
                        route: 'tablero-control-comercio-exterior-venta-por-cliente',
                        resource: 'Tablero Control',
                        action: 'ver-tablero-control-comercio-exterior-venta-por-cliente',
                    },
                    {
                        title: 'tablero.comercio_exterior.menu_vta_x_mercado',
                        route: 'tablero-control-comercio-exterior-venta-por-mercado',
                        resource: 'Tablero Control',
                        action: 'ver-tablero-control-comercio-exterior-venta-por-mercado',
                    },
                ],
            },
            {
                title: 'tablero.ingreso_tributario.menu_title',
                route: 'tablero-control-tributario-ingreso-vs-egresos',
                resource: 'Tablero Control',
                action: 'ver-tablero-control-tributario-ingreso-egreso',
            },
        ],
    },
] as MenuConfig[]
